import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Guide } from "../../models/Guide";
import { getGuides } from "../../repositories/GuideRepository";
import { TableGuide } from "./components/TableGuide";

export const useGuides = (
	partId?: number,
	onError?: (error: Error) => void,
) => {
	return useQuery<Guide[], Error>({
		queryKey: ["guides", partId],
		meta: { realtime: ["M2.GetGuides"] },
		queryFn: ({ signal }) => getGuides({ partId }, signal),
		onError: onError,
	});
};

export const GuidePage = () => {
	const { partId } = useParams();

	return (
		<>
			<HelmetDexteel title="Guides" />
			<TableGuide partId={partId} />
		</>
	);
};
